//emailJS 월 200건
//계정 : noreply@daom04.com

// POST
// https://api.emailjs.com/api/v1.0/email/send

import axios from 'axios';

let send_name = "";
let send_date = "";
let send_deposit_name = "";
let send_amounts = "";
let send_per = "";
let send_phone = "";
let send_email = "";
let send_msg = "";

/**
 * 
 * @param {*} jsonData 
 */
let sendMail = function (jsonData) {
  send_date = !(jsonData.date) == true ? "" : jsonData.date;
  send_name = !(jsonData.name) == true ? "" : jsonData.name;
  send_deposit_name = !(jsonData.deposit_name) == true ? "" : jsonData.deposit_name;
  send_amounts = !(jsonData.amounts) == true ? "" : jsonData.amounts;
  send_per = !(jsonData.per) == true ? "" : jsonData.per;
  send_phone = !(jsonData.phone) == true ? "" : jsonData.phone;
  send_email = !(jsonData.email) == true ? "" : jsonData.email;
  send_msg = !(jsonData.msg) == true ? "" : jsonData.msg;
  

  let url = "https://api.emailjs.com/api/v1.0/email/send";
  let emailJson = {
    "service_id": "service_6oajrnz",
    "template_id": "template_gx95mq4",
    "user_id": "gqSimnzmZXgIGcl0W",
    "template_params": {
      "date": send_date
      , "name": send_name
      , "deposit_name": send_deposit_name
      , "amounts": send_amounts
      , "per": send_per
      , "email": send_email
      , "phone": send_phone
      , "msg": send_msg
    }
    // date : 예약일자
    // name : 예약자명, 성명
    // deposit_name : 입금자명
    // amounts : 예상 입금금액
    // per : 예상 인원
    // phone : 전화번호
    // email : 이메일 주소
    // msg : 메세지
  }

  axios.post(url, emailJson)
    .then(response => {
      console.log('이메일 전송 성공:', response);
    })
    .catch(error => {
      console.error('이메일 전송 실패:', error);
    });

}

export default { sendMail }